import { render, staticRenderFns } from "./YourCorner.vue?vue&type=template&id=9345429e&scoped=true"
import script from "./YourCorner.vue?vue&type=script&lang=js"
export * from "./YourCorner.vue?vue&type=script&lang=js"
import style0 from "./YourCorner.vue?vue&type=style&index=0&id=9345429e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9345429e",
  null
  
)

export default component.exports